import React, { useState } from 'react';
import { FileCode, Loader2, ArrowRight, AlertCircle } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';
export function Login() {
  const {
    identifyUser
  } = useWorkspace();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setIsSubmitting(true);
    setError(null);
    try {
      const success = await identifyUser(email);
      if (!success) {
        setError('User not found. Please check your email or contact your administrator.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-3229">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-200 p-8" data-id="element-3230">
        <div className="flex flex-col items-center text-center mb-8" data-id="element-3231">
          <div className="h-12 w-12 bg-blue-50 rounded-xl flex items-center justify-center mb-4" data-id="element-3232">
            <FileCode className="h-6 w-6 text-blue-600" data-id="element-3233" />
          </div>
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-3234">Welcome back</h1>
          <p className="text-sm text-gray-500 mt-2" data-id="element-3235">
            Enter your email to access the ConfigConsole workspace.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-3236">
          <div data-id="element-3237">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3238">
              Email Address
            </label>
            <input type="email" id="email" required className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-4 py-2.5" placeholder="you@company.com" value={email} onChange={e => {
            setEmail(e.target.value);
            setError(null);
          }} data-id="element-3239" />
          </div>

          {error && <div className="rounded-lg bg-red-50 p-3 flex items-start gap-2" data-id="element-3240">
              <AlertCircle className="h-4 w-4 text-red-600 mt-0.5 flex-shrink-0" data-id="element-3241" />
              <p className="text-sm text-red-600" data-id="element-3242">{error}</p>
            </div>}

          <button type="submit" disabled={isSubmitting || !email.trim()} className="w-full flex items-center justify-center gap-2 bg-gray-900 text-white rounded-lg px-4 py-2.5 text-sm font-medium hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-3243">
            {isSubmitting ? <Loader2 className="h-4 w-4 animate-spin" data-id="element-3244" /> : <>
                Continue
                <ArrowRight className="h-4 w-4" data-id="element-3245" />
              </>}
          </button>
        </form>

        <p className="text-center text-xs text-gray-400 mt-8" data-id="element-3246">
          Protected by ConfigConsole Identity
        </p>
      </div>
    </div>;
}